import '@concretecms/bedrock/assets/bedrock/js/frontend';

import '@concretecms/bedrock/assets/imagery/js/frontend';
import '@concretecms/bedrock/assets/navigation/js/frontend';
import '@concretecms/bedrock/assets/documents/js/frontend';


// import function to register Swiper custom elements
//import { register } from 'swiper/element/bundle';
// register Swiper custom elements
//register();

// document.addEventListener('DOMContentLoaded', function() {
  // const modals = document.querySelectorAll('.modal');
// 
  // modals.forEach(modal => {
    // modal.addEventListener('show.bs.modal', function(event) {
    //   setTimeout(function() {
    //     
    //    const swiperSliderElement = modal.querySelector('swiper-container.mySwiper');
    //    if (swiperSliderElement) {
// 
    //       const params = {
    //         effect: 'coverflow',
    //         grabCursor: true,
    //         centeredSlides: true,
    //         navigation: false,
    //         slidesPerView: 1,
    //         coverflowEffect: {
    //           rotate: 50,
    //           stretch: 0,
    //           depth: 100,
    //           modifier: 1,
    //           slideShadows: false,
    //         },
    //         pagination: {
    //           clickable: true,
    //         },
    //         breakpoints: {
    //           640: {
    //             slidesPerView: 2,
    //             spaceBetween: 20,
    //           },
    //           768: {
    //             slidesPerView: 3,
    //             spaceBetween: 30,
    //           },
    //         },
    //         observer: true,
    //         observeParents: true,
    //         injectStyles: [
    //           `
    //           .swiper-pagination{
    //             top:150px;
    //           }
    //           .swiper-pagination-bullet{
    //             width: 8px;
    //             height: 8px;
    //             background-color: #8BFFDE;
    //           }
    //           `,
    //         ],
    //       };
    //       Object.assign(swiperSliderElement, params);
    //       swiperSliderElement.initialize();
    //       
    //       swiperSliderElement.update();
    //       
    //     }
    //   }, 0);
    // });
  // });
// });





// const swiperEl = document.getElementById('swiperCard')
// 
// const swiperParams = {
  // slidesPerView: 1,
  // spaceBetween: 10,
  // pagination: {
    // clickable: true,
  // },
  // autoplay: {
    //  delay: 5000,
  // },
  // breakpoints: {
    // 640: {
    //   slidesPerView: 2,
    //   spaceBetween: 20,
    // },
    // 768: {
    //   slidesPerView: 3,
    //   spaceBetween: 30,
    // },
    // 1200: {
    //   slidesPerView: 4,
    //   spaceBetween: 30,
    // },
  // },
  // // array with CSS styles
  // injectStyles: [
    // `
    // .swiper-pagination-bullet{
    //   width: 8px;
    //   height: 8px;
    //   background-color: #7256EC;
    // }
    // `,
  // ],
// }
// 
// // now we need to assign all parameters to Swiper element
// Object.assign(swiperEl, swiperParams);
// 
// // and now initialize it
// swiperEl.initialize();




// Bouton Back To Top
var btn = $('#backtotop');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
	btn.addClass('show');
  } else {
	btn.removeClass('show');
  }
});